const React = require('react')
const PropTypes = require('prop-types')

const displayName = require('module/user/helpers/display_name')

function Name(props) {

    return (
        <section>
            <h1 className="name">{displayName(props.user)}</h1>
        </section>
    )

}

Name.propTypes = {
    user: PropTypes.object.isRequired,
}

module.exports = Name
